import { cdlDef } from '../../cdl'

export default cdlDef({ id: 'CDL3WHITESOLDIERS', label: 'Three White Soldiers', lookback: 12 })
